<ds-artwork-card
  [size]="size"
  [imageUrl]="product.ProductImgUrl"
  [name]="product.Name"
  [subtitle]="product.ArtTypeName"
  [price]="displayPrice"
  [status]="statusLabel"
  [statusTone]="statusTone"
  (cardClick)="goToProductDetails(product)">
  @if (isAvailable) {
    <div actions class="w-100 mt-2">
      <button pButton type="button" class="p-button-sm w-100"
        [icon]="!product.requestSent ? 'fa fa-paper-plane' : 'fa fa-check'"
        [disabled]="product.requestSent"
        [ngClass]="product.buttonColorClass"
        [pTooltip]="product.requestSent ? ('artistProductTile.requestSent' | transloco) : ('artistProductTile.requestProduct' | transloco)"
        [tooltipOptions]="{ showDelay: 0 }"
        [label]="product.requestSent ? ('artistProductTile.requestSent' | transloco) : ('artistProductTile.requestProduct' | transloco)"
        (click)="$event.stopPropagation(); sendProductRequestDialog(product)">
      </button>
    </div>
  }
</ds-artwork-card>

<!-- Send product request dialog -->
<p-dialog [header]="'artistProductTile.sendProductRequestOptional' | transloco" [(visible)]="showCommentDialog" [modal]="true"
  [style]="{'width': '530px' }" (onHide)="onCloseDialog()">
  <form class="form-horizontal mt-2 px-3">
    <div class="text-muted small">
      <i class="fa fa-info-circle me-1"></i> {{ 'artistProductTile.commentInfo' | transloco }}
    </div>
    <div class="form-group my-3">
      <div class="panel-container">
        <div class="panel-body position-relative">
          <textarea id="comments" pInputTextarea rows="3" name="comments"
            [(ngModel)]="formData.ProductRequestComment" [placeholder]="'artistProductTile.addComment' | transloco" class="form-control">
          </textarea>
          <div class="emoji-icon position-absolute cursor-pointer fs-5" (click)="openEmojiDialog()"
            style="top: 50%; right: 0.5rem; transform: translateY(-50%);">
            😍
          </div>
          <button pButton type="button" class="p-button-outlined w-100 mt-2"
            [label]="'artistProductTile.sendRequest' | transloco" (click)="sendProductRequest()">
          </button>
        </div>
      </div>
    </div>
  </form>
</p-dialog>
<!-- Emoji Picker Dialog -->
@if (displayEmojiDialog) {
  <app-emoji-list [showDialog]="displayEmojiDialog" (onClose)="closeEmojiDialog($event)" (emojiClick)="addEmoji($event)">
  </app-emoji-list>
}
